import axios from 'axios'
import apiConfig from "@/configs/api"

const http = axios.create({
  baseURL: apiConfig.baseUrl, // 这个请求地址
  withCredentials: true, // 
  timeout: 50000, // 超时时间
})


// 请求配置
http.interceptors.request.use(config => {
  // 是否需要设置 token
  // if (config.formDataShow) {
  //   config.headers['Content-Type'] = 'multipart/form-data'
  //   var formdata = new FormData();
  //   for (const key in config.data) {
  //     if (Object.hasOwnProperty.call(config.data, key)) {
  //       const element = config.data[key];
  //       formdata.append(key, element)
  //     }
  //   }
  //   config.data = formdata
  // }
  // contentType: 'application/x-www-form-urlencoded',
  // const isToken = (config.headers || {}).isToken === false
  // if (getToken() && !isToken) {
  //   config.headers['token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  // }
  return config
})

// 添加响应拦截器
http.interceptors.response.use(async response => {
  let code = response.data.code;
  if (code === 200 || code === 0) {
    return response.data
  }
  Promise.reject(response.data);
}, async error => {
  const errorRes = error.response
  console.log(error)
  if (errorRes.status != 200) {
    // await handleResponse(errorRes)
    return await Promise.reject(errorRes)
  }
  // 对响应错误做点什么
  if (['Network Error'].includes(errorRes.message) || errorRes.message.includes('timeout')) {
    // return await handleResponse({
    //   data: { msg: '网络异常，请稍后重试' }
    // })
  }
})

// function handleResponse (response) {

// }


export default http

